import { Grid, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import Loader from "../../ui/Loader";
import theme from "../../../theme";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
import VoucherLabel from "./VoucherLabel";
import { filterConstants } from "../../../constants/AppConstants";

interface propTypes {
  header: string;
  to: string;
  reportCount: any;
  borderRight?: string;
  canRedirect: boolean;
  loading: boolean;
}

const VoucherDetails = (props: propTypes) => {
  const { header, to, reportCount, borderRight, canRedirect , loading } = props;
  return (
    <Grid width={"50%"} borderRight={borderRight}>
      <Grid height={"30%"} pl={6} display={"flex"} alignItems={"end"} gap={1}>
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: "20px",
            fontWeight: theme.font?.fontWeight.thick,
            color: "#AEAEAE",
          }}
          pb={0.5}
        >
          {header}
        </Typography>
        {canRedirect && (
          <IconButton component={Link} to={`/${to}`}>
            <ArrowForwardIosIcon sx={{ color: "#F1B53D" }} />
          </IconButton>
        )}
      </Grid>
      {loading ? (
        <Grid
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </Grid>
      ) : (
        <Grid
          style={{
            width: "90%",
            height: "70%",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <VoucherLabel
            LabelValue={reportCount?.pending}
            Label={filterConstants.Pending}
          />
          <VoucherLabel
            LabelValue={reportCount?.accept}
            Label={filterConstants.Accepted}
          />
          <VoucherLabel
            LabelValue={reportCount?.reject}
            Label={filterConstants.Rejected}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default VoucherDetails;
